import { useRoadQuery } from "../../../../../common/hooks/queries/useRoadQuery"

import { damagesQueryKeys } from "./queryKeys"

export function useDamageTypesList(config = {}) {
    const url = "damage_types/"

    const queryKey = damagesQueryKeys["types"]()

    return useRoadQuery(
        url,
        queryKey,
        {},
        config,
    )
}
